export const CUSTOMER_PHONE_MIN_LENGTH = 8;
export const CUSTOMER_PHONE_MAX_LENGTH = 15;

/** Strips spaces and non-digits, then caps at E.164 length. */
export function formatCustomerPhone(value: unknown): string {
  if (value == null) {
    return "";
  }
  return String(value)
    .replace(/\D/g, "")
    .slice(0, CUSTOMER_PHONE_MAX_LENGTH);
}

/** Empty is allowed. Non-empty values must already be 8–15 digits with no spaces. */
export function isCustomerPhoneFormatValid(value: unknown): boolean {
  const raw = value == null ? "" : String(value).trim();
  if (!raw) {
    return true;
  }
  return new RegExp(`^\\d{${CUSTOMER_PHONE_MIN_LENGTH},${CUSTOMER_PHONE_MAX_LENGTH}}$`).test(raw);
}
